// [TEMP-DATADOG-OFF] Datadog 계약 만료로 임시 비활성화. 복구 시 아래 import 및 함수 본문 주석 해제.
// import { datadogRum } from '@datadog/browser-rum';

import type { UserLevel } from '@/store/server/common/auth/auth.dto';

interface UserSessionDatadog {
  id?: string;

  level?: UserLevel;
  name?: string;
  account?: string;
}

// [TEMP-DATADOG-OFF] wrapper no-op화 (시그니처 유지, 호출부 영향 없음)
export const setUserSessionDatadog = (_params: UserSessionDatadog) => {
  // datadogRum.setUser({
  //   ...(_params.id && { id: _params.id }),
  //   ...(_params.level && { level: _params.level }),
  // });
};

export const updateUserSessionDatadog = (_params: UserSessionDatadog) => {
  // if (_params.level) datadogRum.setUserProperty('level', _params.level);
  // if (_params.name) datadogRum.setUserProperty('name', _params.name);
  // if (_params.account) datadogRum.setUserProperty('account', _params.account);
};

export const addDatadogError = (_error: Error) => {
  // datadogRum.addError(_error);
};
